import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import Headroom from 'react-headroom';

import HorizontalContainer from '../HorizontalContainer';
import VerticalContainer from '../VerticalContainer';
import Nav from '../Nav';
import Logo from '../Logo';

const { header } = hh(h);
import styles from './header.css';

const Header = (props) => {
    const options = {
        disableInlineStyles: true,
        wrapperStyle: {
            height: '100%'
        }
    };

    return (
        h(Headroom, R.merge(options, props), [
            h(HorizontalContainer, [
                h(VerticalContainer, {size: 'small'}, [
                    header({className: styles.header}, [
                        h(Logo),
                        h(Nav)
                    ])
                ])
            ])
        ])
    );
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/Header/index.js
 **/